import oikosApi from '../../services/oikos'
import api_powerapps from '../../services/powerapps/index'
import { saveAs } from 'file-saver'
import qs from 'qs'
import store from '../../store'
import { graphClient } from '../../store/sagas/auth'
import moment from 'moment';
import { notifyError } from '../notify'
import JSZip from 'jszip'
import assert from 'assert'
import currencyFormatter from '../currencyFormatter'

export function symmetricRound(num, places = 2) {
  var mult = Math.pow(10, places);
  return Number((Math.round(num * mult) / mult).toFixed(places));
}

export async function getOikosId() {
  const estado = store.getState()
  const data = {}
  data['graph_id'] = estado.auth.user.id
  try {
    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get_user',
      data,
    })}`)
    console.log("localizou usuário");
    return res.data
  } catch (err) {
    console.log('ocorreu um erro em getRegs')
  }
}

const GET_URI_SAFE_LEN = 3500

export async function oikosGet(payload) {
  const qsStr = qs.stringify(payload)
  if (qsStr.length > GET_URI_SAFE_LEN) {
    return oikosApi.post('/', payload)
  }
  return oikosApi.get(`/?${qsStr}`)
}

export async function getRegs (table, data = {}, fields = {}, getActive = true) {
  if (getActive) {
    data[`${table}_ativo`] = 1
  }
  try {
    const res = await oikosGet({
      action: 'get',
      table,
      data,
      fields,
    })
    return res.data
  } catch (err) {
    console.log('ocorreu um erro em getRegs')
  }
}

export async function getReg (table, id, fields = {}) {
  const data = {}
  data[`${table}_ativo`] = 1
  data[`${table}_id`] = id
  try {
    const regs = await getRegs(table, data, fields)
    return regs[0]
  } catch (err) {
    console.log('ocorreu um erro em getReg')
  }
}
export async function getRegValue (table, id, field, fields = {}) {
  try {
    const reg = await getReg(table, id, fields)
    return reg[field]
  } catch (err) {
    console.log('ocorreu um erro em getRegValue')
  }
}

export async function selectValues(table, value, label, filter = {}, fields = {}) {
  try {
    const data = await getRegs(table, filter, fields)
    console.log('data selectValues: ', data)
    const select_values = data.map((item) => {
      const initialObj = { value: item[`${value}`], label: item[`${label}`] }
      if (Object.keys(fields).length > 0) {
        for (const value of Object.values(fields)) {
          initialObj[value] = item[value]
        }
      }
      return initialObj })
    return select_values
  } catch (err) {
    console.log('ocorreu um erro em selectValues')
  }
}

export async function insert(table, data) {
  const payload = Object.fromEntries(
    Object.entries(data || {}).filter(([, v]) => v !== null && v !== undefined)
  )
  try {
    const insertReq = await oikosApi.post('/', { action: 'insert', table, data: payload })
    console.log('item inserido com sucesso na tabela ', insertReq)
    return insertReq.data[0][`${table}_id`]
  } catch (e) {
    console.log('Houve um erro na inserção de item na tabela ', table, ' erro: ', e)
  }
}

export async function update(table, id, data) {
  data[`${table}_id`] = id
  try {
    const updateReq = await oikosApi.post('/', { action: 'update', table, data })
    console.log('item atulizado com sucesso na tabela ', updateReq.data)
    return id
  } catch (e) {
    console.log('Houve um erro na atualização do item na tabela ', table, ' erro: ', e)
  }
}

export async function updateField(table, id, field, value) {
  const data = {}
  data[`${table}_id`] = id
  data[field] = value
  try {
    const updateReq = await oikosApi.post('/', {
      action: 'update',
      table,
      data,
    })
    console.log('item atulizado com sucesso na tabela ', table, updateReq)
  } catch (e) {
    console.log('Houve um erro na atualização do item na tabela ', table, ' erro: ', e)
  }
}

export async function del(table, id ) {
  const data = {}
  data[`${table}_id`] = id
  try {
    const deleteReq = await oikosApi.post('/', { action: 'delete', table, data })
    console.log('item excluido com sucesso na tabela ', table, deleteReq)
  } catch (e) {
    console.log('Houve um erro na exclusão de item na tabela ', table, ' erro: ', e)
  }
}

export async function insOrUp(table, data) {
  return data[`${table}_id`] ? update(table, data[`${table}_id`], data) : insert(table, data)
}

export async function getDocs(table, id) {
  try {
    const formData = new FormData()
    formData.append('acao', 'get_docs')
    formData.append('obj_table', table)
    formData.append('obj_id', id)
    const res = await api_powerapps.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })
    return res.data
  } catch (e) {
    console.log('ocorreu um erro em getDocs', e)
  }
}

export function forceDownload(fileUrl, fileName, contentType = 'application/pdf') {
  saveAs(fileUrl, fileName, { type: contentType });
}

export async function getProjectTeam(projId) {
  try {
    const formData = new FormData()
    formData.append('acao', 'listar_equipe_projeto_id')
    formData.append('proj_id', projId)

    const res = await api_powerapps.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })
    return res.data

  } catch (e) {
    console.log('ocorreu um erro em getProjectTeam')
  }
}

export const SQL_PF_ID_COORDENADOR = "(SELECT pe.pf_id FROM prodStatusAlt psa, projEquipe pe WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)"

export const SQL_PF_ID_COORDENADOR_ATUAL = "(SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1)"

export const PROD_COORDENADOR_PF_FIELDS = {
  [SQL_PF_ID_COORDENADOR]: 'pf_id_coordenador',
  [SQL_PF_ID_COORDENADOR_ATUAL]: 'pf_id_coordenador_atual',
}

export function getProdCoordenadorPfId(produto = {}) {
  return produto.pf_id_coordenador ?? produto.pf_id_coordenador_atual
}

export async function sendMail(to, subject, message, cc) {
  try {
    const body = {
      acao: 'enviar_email',
      to_mail: to,
      subject,
      msg: message,
      to_name: to,
      reply_mail: 'oikos@ecoss.is',
      reply_name: 'Oikos',
    }

    const res = await api_powerapps.post('/', body, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })
    console.log('enviar_email = ', res)

    return true
  }
  catch (err) {
    console.log(err)
    return false
  }
}

export async function getProdutoFinalDoc(linkPastaProduto, targetUserEmail) {
  try {
   const base64Encoded = btoa(linkPastaProduto);
   const fileName = 'Produto Final.docx';

   const productFolder = await graphClient.api(`/shares/u!${base64Encoded}/driveItem`).get();
   const targetUser = await graphClient.api(`/users/${targetUserEmail}`).get();
   const targetDriveId = targetUser.id;
   const getProdutoFinalDoc = await graphClient.api(`/users/${targetDriveId}/drive/items/${productFolder.id}/children`)
   .filter(`name eq '${fileName}'`)
   .get();
   const getAnexosFolder = await graphClient.api(`/users/${targetDriveId}/drive/items/${productFolder.id}/children`)
   .filter(`name eq 'Anexos'`)
   .get();

   return { getProdutoFinalDoc, getAnexosFolder};

  }
  catch (err) {
    console.log(err)
  }
}

// pega o produto final do oneDrive, sendo ele de qualquer extensão.
export async function getProdutoFinal(linkPastaProduto, targetUserEmail, prodFormato='') {
  try {
   const base64Encoded = btoa(linkPastaProduto);
   const sufixoProdFinal = `_prodfinal${prodFormato}`;

   const productFolder = await graphClient.api(`/shares/u!${base64Encoded}/driveItem`).get();
   const targetUser = await graphClient.api(`/users/${targetUserEmail}`).get();
   const targetDriveId = targetUser.id;

      console.log(targetDriveId)
      console.log(productFolder.id)
   const allItems = await graphClient.api(`/users/${targetDriveId}/drive/items/${productFolder.id}/children`).get();
   const produtoFinal = allItems.value
   .filter(item => item.name.endsWith(sufixoProdFinal))
   .sort((a, b) => new Date(b.createdDateTime) - new Date(a.createdDateTime));

   if (produtoFinal.length > 0) {
    const latestProdFinal = produtoFinal[0];
    console.log('Latest PDF:', latestProdFinal);
    return latestProdFinal;
    /*
    const mostRecentProd = produtoFinal.reduce((mostRecent, current) => {
      return new Date(mostRecent.createdDateTime) > new Date(current.createdDateTime) ? mostRecent : current;
    })
    return mostRecentProd;
    */
   }

   if (produtoFinal.length === 0) {
    return null;
   }
  }
  catch (err) {
    console.log(err)
  }
}

export async function getLatestPdfInFolder(linkPastaProdutoFinal, targetUserEmail) {
  try {
    const base64Encoded = btoa(linkPastaProdutoFinal);
    const productFolder = await graphClient.api(`/shares/u!${base64Encoded}/driveItem`).get();

    // Step 1: Get the target user's Drive ID
    const targetUser = await graphClient.api(`/users/${targetUserEmail}`).get();
    const targetDriveId = targetUser.id;

    // Step 2: List all items in the specified folder
    const itemsInFolder = await graphClient.api(`/users/${targetDriveId}/drive/items/${productFolder.id}/children`).get();

    // Step 3: Filter PDF files and sort by creation date
    const pdfFiles = itemsInFolder.value
      .filter(item => item.name.endsWith('_prodfinal.pdf')) // Only PDFs
      .sort((a, b) => new Date(b.createdDateTime) - new Date(a.createdDateTime)); // Sort by creation date

    // Step 4: Return the latest PDF (first item in the sorted array)
    if (pdfFiles.length > 0) {
      const latestPdf = pdfFiles[0];
      console.log('Latest PDF:', latestPdf);
      return latestPdf;
    } else {
      console.log('No PDFs found in the folder.');
      return null;
    }
  } catch (error) {
    console.error('Error retrieving the latest PDF:', error);
    throw error;
  }
}

export async function criaLinkVisualizacaoProdFinal(latestFile, targetUserEmail) {
  try {

    const targetUser = await graphClient.api(`/users/${targetUserEmail}`).get();
    const targetDriveId = targetUser.id;

    const criaLink = await graphClient.api(`/users/${targetDriveId}/drive/items/${latestFile.id}/createLink`)
    .post({
        type: "view",
        scope: "anonymous",
      });

    return criaLink.link.webUrl
  } catch (error) {
    console.error(error);
  }
}

export async function getLastDateStatus(statusNumber, prod_id) {
  try {
    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prodStatusAlt',
      order_field: 'prodStatusAlt_dtCria',
		  order_dir: 'DESC',
      data: {
        prod_id: prod_id,
        prodStatusTp_id: statusNumber,
        prodStatusAlt_ativo: 1,
      },
    })}`)
    return res.data
  } catch (err) {
    console.log(err)
    console.log('nao foi possível capturar as datas dos status')
  }
}

export async function postStatusAltConcluido(prod_id) {
  try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'prod',
        data: {
          prod_id: prod_id
        },
      })}`)

      const prod = res.data[0];

      let vinculationBody = {};

      if (prod.prod_dtAprov) {

        vinculationBody = {
          action: 'insert',
          table: 'prodStatusAlt',
          data: {
            prod_id: prod_id,
            prodStatusTp_id: 7,
            pf_id: prod.prod_responsavel,
            prodStatusAlt_obs: 'migrando do sharepoint para o oikos',
            prodStatusAlt_usuarioMod: 141,
            prodStatusAlt_usuarioCria: 141,
            prodStatusAlt_data: prod.prod_dtAprov,
            prodStatusAlt_dtCria: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_dtMod: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_ativo: 1,
          },
        }
      } else {
        vinculationBody = {
          action: 'insert',
          table: 'prodStatusAlt',
          data: {
            prod_id: prod_id,
            prodStatusTp_id: 7,
            pf_id: prod.prod_responsavel,
            prodStatusAlt_obs: 'migrando do sharepoint para o oikos',
            prodStatusAlt_usuarioMod: 141,
            prodStatusAlt_usuarioCria: 141,
            prodStatusAlt_atencaoData: 1,
            prodStatusAlt_dtCria: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_dtMod: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_ativo: 1,
          },
        }
      }

      await oikosApi.post('/', vinculationBody)

  } catch (err) {
    console.log(err)
    console.log('nao foi possível capturar as datas dos status')
  }
}

export async function postStatusAltEntregue(prod_id) {
  try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'prod',
        data: {
          prod_id: prod_id
        },
      })}`)

      const prod = res.data[0];

      let vinculationBody = {};

      if (prod.prod_dtEntrega) {

        vinculationBody = {
          action: 'insert',
          table: 'prodStatusAlt',
          data: {
            prod_id: prod_id,
            prodStatusTp_id: 6,
            pf_id: prod.prod_responsavel,
            prodStatusAlt_obs: 'migrando do sharepoint para o oikos',
            prodStatusAlt_usuarioMod: 141,
            prodStatusAlt_usuarioCria: 141,
            prodStatusAlt_data: prod.prod_dtEntrega,
            prodStatusAlt_dtCria: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_dtMod: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_ativo: 1,
          },
        }
      } else {
        vinculationBody = {
          action: 'insert',
          table: 'prodStatusAlt',
          data: {
            prod_id: prod_id,
            prodStatusTp_id: 6,
            pf_id: prod.prod_responsavel,
            prodStatusAlt_obs: 'migrando do sharepoint para o oikos',
            prodStatusAlt_usuarioMod: 141,
            prodStatusAlt_usuarioCria: 141,
            prodStatusAlt_atencaoData: 1,
            prodStatusAlt_dtCria: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_dtMod: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_ativo: 1,
          },
        }
      }

      await oikosApi.post('/', vinculationBody)

  } catch (err) {
    console.log(err)
    console.log('nao foi possível capturar as datas dos status')
  }
}

export async function postStatusAltNaoIniciado(prod_id) {
  try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'prod',
        data: {
          prod_id: prod_id
        },
      })}`)

      const prod = res.data[0];

      let vinculationBody = {};

      if (prod.prod_dtContrato) {

        vinculationBody = {
          action: 'insert',
          table: 'prodStatusAlt',
          data: {
            prod_id: prod_id,
            prodStatusTp_id: 1,
            pf_id: prod.prod_responsavel,
            prodStatusAlt_obs: 'migrando do sharepoint para o oikos',
            prodStatusAlt_usuarioMod: 141,
            prodStatusAlt_usuarioCria: 141,
            prodStatusAlt_data: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_dtCria: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_dtMod: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_ativo: 1,
          },
        }
      } else {
        vinculationBody = {
          action: 'insert',
          table: 'prodStatusAlt',
          data: {
            prod_id: prod_id,
            prodStatusTp_id: 1,
            pf_id: prod.prod_responsavel,
            prodStatusAlt_obs: 'migrando do sharepoint para o oikos',
            prodStatusAlt_usuarioMod: 141,
            prodStatusAlt_usuarioCria: 141,
            prodStatusAlt_atencaoData: 1,
            prodStatusAlt_dtCria: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_dtMod: moment().format('YYYY-MM-DD hh:mm:ss'),
            prodStatusAlt_ativo: 1,
          },
        }
      }

      await oikosApi.post('/', vinculationBody)

  } catch (err) {
    console.log(err)
    console.log('nao foi possível capturar as datas dos status')
  }
}

export async function sendEmailToNotify(to, subject, message, cc) {
  try {
    const body = {
      acao: 'send_mail',
      to_mail: to,
      to_name: to,
      cc_mail: cc || '',
      subject,
      msg: message,
      reply_mail: 'oikos@ecoss.is',
      reply_name: 'Oikos',
    }

    const res = await api_powerapps.post('/', body, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })
    console.log('enviar_email = ', res)
    return true
  }
  catch (err) {
    console.log(err)
    return false
  }
}

export function printStandardEmail(content) {
  return `
  <html>
    <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <style>
            body {
                font-family: Arial, sans-serif;
                color: #273351; /* Cor principal da marca */
                margin: 0;
                padding: 0;
                background-color: #f4f4f4;
            }
            .container {
                width: 120%;
                max-width: 700px;
                margin: 50 auto;
                background-color: #ffffff;
                padding: 20px;
                border-radius: 5px;
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
            }
            .header {
                text-align: center;
                padding-bottom: 20px;
            }
            .header img {
                max-width: 150px;
            }
            .content {
                font-size: 16px;
                line-height: 1.6;
                color: #273351;
            }
            .content p {
                margin-bottom: 20px;
            }
            .footer {
                text-align: center;
                padding-top: 20px;
                font-size: 14px;
                color: #999999;
            }
            .footer a {
                color: #273351;
                text-decoration: none;
            }
            .footer img {
                max-width: 90%;
                height: auto;
                margin-top: 20px;
            }
    </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <img src="https://ecossis.com/www1/wp-content/uploads/2024/08/Design-sem-nome-11.png" alt="Ecossis Logo">
        </div>
        <div class="content">
          ${content}
        </div>
        <div class="footer">
          <p>&copy; 2024 Ecossis Soluções Ambientais. Todos os direitos reservados.</p>
          <p>Visite nosso site: <a href="https://www.ecossis.com" target="_blank">www.ecossis.com</a></p>
          <img src="https://ecossis.com/www1/wp-content/uploads/2024/08/Ass_2024_2.png" alt="Imagem de Assinatura">
        </div>
      </div>
    </body>
  </html>
`
}

function uniqueEmails(list) {
  const seen = new Set()
  const result = []
  const items = Array.isArray(list) ? list : [list]
  for (const raw of items) {
    const email = String(raw || '').trim()
    if (!email) continue
    const key = email.toLowerCase()
    if (seen.has(key)) continue
    seen.add(key)
    result.push(email)
  }
  return result
}

async function sendNotifyOnce(toList, ccList, subject, body) {
  const tos = uniqueEmails(toList)
  const toKeys = new Set(tos.map((email) => email.toLowerCase()))
  const ccs = uniqueEmails(ccList).filter((email) => !toKeys.has(email.toLowerCase()))
  if (!tos.length) return false
  return sendEmailToNotify(tos.join(','), subject, body, ccs.join(','))
}

export async function notifyByEmail(prod_id, info={}) {
  //Essa função deve ser chamada após o status ser atualizado
  //info = {emailClientes: [], prodFormato: string, obs: string}

  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'prod',
    data: {
      prod_id: prod_id
    },
    fields: {
      "(SELECT pfCoord.pf_emailProf FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavel_email",

  "(SELECT pfCoord.pf_nomeExibicao FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavelNome",
    '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavelNomeAtual',
    '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavel_email_atual',
      '(SELECT proj_nome FROM proj WHERE proj.proj_id = prod.proj_id)': 'proj_nome',
      '(SELECT pf.pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT psa.prodStatusAlt_usuarioCria FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY psa.prodStatusAlt_dtCria DESC LIMIT 1))': 'prodStatusAlt_usuarioMovimentacao',
      '(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusActual_id',
      '(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1 OFFSET 1)': 'prodStatusPenultimo_id',
      '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 6)': 'hasStatus6',
      '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 5)': 'hasStatus5',
      '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 4)': 'hasStatus4',
    }
  })}`)

  const product = res.data[0];

  const coordenadorEmail = `${product.prod_responsavel_email ?? product.prod_responsavel_email_atual}`
  const diretorEmail = 'diretoria.tecnica@ecossis.com.br'
  const gerenteEmail = 'gerente.tecnico@ecossis.com.br'
  const gerenteFinanceiroEmail = 'gerencia.financeira@ecossis.com.br'
  const financeiroEmail = 'financeiro@ecossis.com.br'
  const revisorEmail = 'revisaoep@ecossis.com.br'
  /*
  const coordenadorEmail = `pedro.gasparotto@ecossis.com.br`
  const diretorEmail = 'pedro.gasparotto@ecossis.com.br'
  const gerenteEmail = 'pedro.gasparotto@ecossis.com.br'
  const gerenteFinanceiroEmail = 'pedro.gasparotto@ecossis.com.br'
  const financeiroEmail = 'pedro.gasparotto@ecossis.com.br'
  const revisorEmail = 'pedro.gasparotto@ecossis.com.br'
  */
  //const clienteEmail = contratoInfo.pj_responsavel_email

  if (product.prodStatusActual_id === 3) {
    await sendNotifyOnce(
      [revisorEmail],
      [coordenadorEmail],
      `Produto ${product.prod_desc} entregue para revisão`,
      printStandardEmail(`
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        O produto <strong>${product.prod_desc}</strong> foi entregue para a revisão<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${info.obs}
      `)
    )
  }

  if (product.prodStatusActual_id === 4 && product.prodStatusPenultimo_id === 2) {
    await sendNotifyOnce(
      [gerenteEmail],
      [coordenadorEmail, diretorEmail],
      `Produto ${product.prod_desc} enviado para a gestão`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        O produto <strong>${product.prod_desc}</strong> foi enviado para a gerência sem passar pela Revisão<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${info.obs}`
      )
    )
  }

  if (product.prodStatusActual_id === 4 && product.prodStatusPenultimo_id === 3) {

    const listaParecer = JSON.parse(info.obs);
    console.log(listaParecer);
    let parecerHtml = '';
    for (let parecer of listaParecer) {
      console.log(parecer);
      parecerHtml = `${parecerHtml}${parecer.obsNum} - ${parecer.observacao} - Página: ${parecer.pagina}<br/>`
    }

    console.log(parecerHtml);

    await sendNotifyOnce(
      [gerenteEmail],
      [revisorEmail, coordenadorEmail, diretorEmail],
      `Produto ${product.prod_desc} aprovado pelo(a) Revisor(a)`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        O produto <strong>${product.prod_desc}</strong> foi aprovado pelo(a) revisor(a) e enviado para a gerência<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${parecerHtml}`
      )
    )
  }

  if (product.prodStatusActual_id === 9 && product.prodStatusPenultimo_id === 3) {

    const listaParecer = JSON.parse(info.obs);
    let parecerHtml = '';
    for (let parecer of listaParecer) {
      parecerHtml = `${parecerHtml}${parecer.obsNum} - ${parecer.observacao} - Página: ${parecer.pagina}<br/>`
    }

    await sendNotifyOnce(
      [coordenadorEmail],
      [gerenteEmail, diretorEmail, revisorEmail],
      `Produto ${product.prod_desc} rejeitado pelo(a) Revisor(a)`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        O produto <strong>${product.prod_desc}</strong> foi rejeitado pelo(a) revisor(a) e enviado para correção<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${parecerHtml}`
      )
    )
  }

  if (product.prodStatusActual_id === 4 && product.prodStatusPenultimo_id === 9 && product.hasStatus4 === 1 && product.hasStatus5 === 0) {
    await sendNotifyOnce(
      [gerenteEmail],
      [coordenadorEmail, diretorEmail],
      `Produto ${product.prod_desc} corrigido pelo(a) Coordenador(a)`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        A pedido do(a) Revisor(a), o produto <strong>${product.prod_desc}</strong> foi corrigido pelo(a) Coordenador(a) e enviado para Gerência<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${info.obs}`
      )
    )
  }

  if (product.prodStatusActual_id === 4 && product.prodStatusPenultimo_id === 9 && product.hasStatus4 > 1 && product.hasStatus5 === 0 ) {
    await sendNotifyOnce(
      [gerenteEmail],
      [coordenadorEmail, diretorEmail],
      `Produto ${product.prod_desc} corrigido pelo(a) Coordenador(a)`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        A pedido do(a) Gerente, o produto <strong>${product.prod_desc}</strong> foi corrigido pelo(a) Coordenador(a) e enviado para Gerência<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${info.obs}`
      )
    )
  }

  if (product.prodStatusActual_id === 4 && product.prodStatusPenultimo_id === 9 && product.hasStatus6 > 0) {
    await sendNotifyOnce(
      [gerenteEmail],
      [coordenadorEmail, diretorEmail],
      `Produto ${product.prod_desc} corrigido pelo(a) Coordenador(a)`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        A pedido do(a) Cliente, o produto <strong>${product.prod_desc}</strong> foi corrigido pelo(a) Coordenador(a) e enviado para Gerência<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${info.obs}`
      )
    )
  }

  if (product.prodStatusActual_id === 5 && product.prodStatusPenultimo_id === 4) {
    await sendNotifyOnce(
      [coordenadorEmail],
      [gerenteEmail, diretorEmail, financeiroEmail, gerenteFinanceiroEmail],
      `Produto ${product.prod_desc} aprovado pelo(a) Gestor(a)`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        O produto <strong>${product.prod_desc}</strong> foi aprovado pelo(a) Gestor(a) e está pronto para ser enviado ao Cliente<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${info.obs}`
      )
    )
  }

  if (product.prodStatusActual_id === 9 && product.prodStatusPenultimo_id === 4) {
    await sendNotifyOnce(
      [coordenadorEmail],
      [gerenteEmail, diretorEmail],
      `Produto ${product.prod_desc} reprovado pelo(a) Gestor(a)`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        O produto <strong>${product.prod_desc}</strong> foi reprovado pelo(a) Gestor(a) e enviado para correção<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${info.obs}`
      )
    )
  }

  if (product.prodStatusActual_id === 5 && product.prodStatusPenultimo_id === 9 && product.hasStatus6 === 0) {
    await sendNotifyOnce(
      [coordenadorEmail],
      [gerenteEmail, diretorEmail, financeiroEmail, gerenteFinanceiroEmail],
      `Produto ${product.prod_desc} aprovado pelo(a) Gestor(a)`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        A pedido do(a) Gestor(a), o produto <strong>${product.prod_desc}</strong> foi corrigido pelo(a) Coordenador(a), aprovado pelo(a) Gestor(a) e está pronto para ser enviado ao Cliente<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${info.obs}`
      )
    )
  }

  if (product.prodStatusActual_id === 5 && product.prodStatusPenultimo_id === 9 && product.hasStatus6 > 0) {
    await sendNotifyOnce(
      [coordenadorEmail],
      [gerenteEmail, diretorEmail, financeiroEmail, gerenteFinanceiroEmail],
      `Produto ${product.prod_desc} aprovado pelo(a) Gestor(a)`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        A pedido do(a) Cliente, o produto <strong>${product.prod_desc}</strong> foi corrigido pelo(a) Coordenador(a), aprovado pela Gestão e está pronto para ser enviado ao Cliente<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${info.obs}`
      )
    )
  }


  //aqui precisamos adicionar o link de apenas vizualização
  if (product.prodStatusActual_id === 6 && (product.hasStatus6 - 1) === 0) {
    await sendNotifyOnce(
      info.emailsCliente,
      [coordenadorEmail, financeiroEmail, gerenteFinanceiroEmail],
      `${product.prod_desc} - Entrega oficial de produto final`,
      printStandardEmail(
        `
          Prezado(a) Cliente,<br/>
          <strong>Atenção: Este é um email automático.</strong><br/>
          <span>Caso queira contatar o coordenador responsável pelo produto, faça o contato pelo email:</span> <strong>${product.prod_responsavel_email ?? product.prod_responsavel_email_atual}</strong><br/>
          <br/>
          segue o link de acesso do produto <strong>${product.prod_desc}</strong><br />
          <a href=${info.linkDownloadProdFinalZip}>Link para download do produto</a><br/>
          Observações:<br/>
          ${info.obs}`
      )
    )
  }

  //aqui precisamos adicionar o link de apenas vizualização
  if (product.prodStatusActual_id === 6 && (product.hasStatus6 - 1) !== 0) {
    await sendNotifyOnce(
      info.emailsCliente,
      [coordenadorEmail, financeiroEmail, gerenteFinanceiroEmail],
      `${product.prod_desc} - Entrega oficial de produto final`,
      printStandardEmail(
        `
          Prezado(a) Cliente,<br/>
          <strong>Atenção: Este é um email automático.</strong><br/>
          <span>Caso queira contatar o coordenador responsável pelo produto, faça o contato pelo email:</span> <strong>${product.prod_responsavel_email ?? product.prod_responsavel_email_atual}</strong><br/>
          <br/>
          realizamos as correções exigidas. Segue o link de acesso do produto <strong>${product.prod_desc}</strong><br />
          <a href=${info.linkDownloadProdFinalZip}>Link para download do produto</a><br/>
          Observações:<br/>
          ${info.obs}`
      )
    )
  }

  if (product.prodStatusActual_id === 9 && product.prodStatusPenultimo_id === 6) {
    await sendNotifyOnce(
      [coordenadorEmail],
      [financeiroEmail, gerenteFinanceiroEmail, diretorEmail, gerenteEmail],
      `Produto ${product.prod_desc} reprovado pelo(a) Cliente`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        Produto ${product.prod_desc} foi reprovado pelo cliente<br/>
        Segue o link de acesso e a evidência de reprovação do produto <strong>${product.prod_desc}</strong><br />
        <a href=https://oikos.ecoss.is/oikos/${info.linksEvidencias[info.linksEvidencias.length - 1]}>Link para acessar a evidência</a><br/>
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${info.obs}`
      )
    )
  }

  if (product.prodStatusActual_id === 7) {
    await sendNotifyOnce(
      [coordenadorEmail],
      [gerenteEmail, diretorEmail, financeiroEmail, gerenteFinanceiroEmail],
      `Produto ${product.prod_desc} aprovado pelo(a) Cliente`,
      printStandardEmail(
        `
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>R$ ${'Valor ocultado'}</span><br />
        <br />
        Produto ${product.prod_desc} foi aprovado pelo cliente!<br/>
        Segue o link de acesso e a evidência de aprovação do produto <strong>${product.prod_desc}</strong><br />
        <a href=https://oikos.ecoss.is/oikos/${info.linksEvidencias[info.linksEvidencias.length - 1]}>Link para acessar a evidência</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        <a href=${product.prod_drive}>Link para a pasta do produto</a>`
      )
    )
  }

  if (Number(product.prodStatusActual_id) === 8) {
    const vlrSrc = info.vlrLiberado != null && info.vlrLiberado !== ''
      ? info.vlrLiberado
      : product.prod_vlr
    const valorFmt = Number.isFinite(Number(vlrSrc))
      ? currencyFormatter.format(Number(vlrSrc))
      : (vlrSrc ?? '—')
    const dtAutRaw = info.dtAutFat || product.prod_dtAutFat
    const dtAutFmt = dtAutRaw
      ? moment(dtAutRaw).format('DD/MM/YYYY')
      : '—'

    const bodyFaturamento = printStandardEmail(`
        <strong>Data da movimentação: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Produto movimentado por: </strong><span>${product.prodStatusAlt_usuarioMovimentacao}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato || '—'}</span><br />
        <strong>Data de autorização de faturamento: </strong><span>${dtAutFmt}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome}</span><br />
        <strong>Valor: </strong><span>${valorFmt}</span><br />
        <br />
        O produto <strong>${product.prod_desc}</strong> recebeu autorização de faturamento.<br />
        <a href=${product.prod_drive}>Link para a pasta do produto</a><br/>
        <a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>
        Observações:<br/>
        ${info.obs || ''}
      `)

    // Destino solicitado: financeiro@ (grafia correta) e gerência financeira
    await sendNotifyOnce(
      [financeiroEmail],
      [gerenteFinanceiroEmail],
      `Produto ${product.prod_desc} com faturamento autorizado`,
      bodyFaturamento,
    )
  }
}

const EMAIL_GERENCIA_FINANCEIRA = 'gerencia.financeira@ecossis.com.br'
const EMAIL_DIRETORIA_EXECUTIVA = 'diretoria.executiva@ecossis.com.br'

const formatYmdBr = (value) => {
  if (!value) return '—'
  const m = moment(value)
  return m.isValid() ? m.format('DD/MM/YYYY') : '—'
}

/** Aviso quando a data de liberação de faturamento (`prod_dtAutFat`) é alterada na grelha. */
export async function notifyDtLiberacaoFaturamentoAlterada({
  product = {},
  previousDate,
  newDate,
  usuario,
} = {}) {
  const vlrSrc = product.prod_vlr
  const valorFmt = Number.isFinite(Number(vlrSrc))
    ? currencyFormatter.format(Number(vlrSrc))
    : (vlrSrc ?? '—')
  const desc = product.prod_desc || `#${product.prod_id || '—'}`
  const subject = `Produto ${desc} — data de liberação de faturamento alterada`
  const body = printStandardEmail(`
        <strong>Data da alteração: </strong><span>${moment().format('DD/MM/YYYY HH:mm')}</span><br />
        <strong>Alterado por: </strong><span>${usuario || '—'}</span><br />
        <strong>Data de entrega contratual: </strong><span>${product.prod_dtContrato ? formatYmdBr(product.prod_dtContrato) : '—'}</span><br />
        <strong>Data anterior de liberação de faturamento: </strong><span>${formatYmdBr(previousDate)}</span><br />
        <strong>Nova data de liberação de faturamento: </strong><span>${formatYmdBr(newDate)}</span><br />
        <strong>Projeto: </strong><span>${product.proj_nome || '—'}</span><br />
        <strong>Valor: </strong><span>${valorFmt}</span><br />
        <br />
        A data de liberação de faturamento do produto <strong>${desc}</strong> foi alterada.<br />
        ${product.prod_drive ? `<a href=${product.prod_drive}>Link para a pasta do produto</a><br/>` : ''}
        ${product.proj_id ? `<a href=https://oikos.ecoss.is/oikos-client/dep-tecnico/projetos/${product.proj_id}>Link para a pagina do projeto</a><br/>` : ''}
      `)

  await sendEmailToNotify(EMAIL_GERENCIA_FINANCEIRA, subject, body)
  await sendEmailToNotify(EMAIL_DIRETORIA_EXECUTIVA, subject, body)
}

export async function postEvidenceInOikos(files, produto={}) {
  if (files.length > 0) {
    await Promise.all(files.map(async file => {
      // Cria um registro na tabela de documentos para cada arquivo
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: 24,
          documento_desc: `Evidência do produto ${produto.prod_desc}`,
          documento_iniVig: undefined,
          documento_fimVig: undefined,
          documento_dtEmissao: undefined,
          documento_prazo: undefined,
          documento_ref: undefined,
          privacidade_id: 2,
        },
      }
      const documentCreated = await oikosApi.post('/', documentBody)

      // Cria uma vinculação entre o documento (anexo) e o registro da minuta
      if (documentCreated.data[0].documento_id) {
        const vinculationBody = {
          action: 'insert',
          table: 'documentoVinc',
          data: {
            documento_id: documentCreated.data[0].documento_id,
            documentoVinc_tabRef: 'prod',
            documentoVinc_tabId: produto.prod_id,
          },
        }
        await oikosApi.post('/', vinculationBody)
      }

      // Faz upload do arquivo e registra na tabela 'arquivo'
      const formData = new FormData()
      formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
      formData.append('table', 'arquivo')
      formData.append('action', 'upload_file')
      formData.append('arquivo_tabRef', 'documento')
      formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
      formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
      formData.append('arquivo_desc', file.data.path)
      const fileUploadRes = await oikosApi.post('/', formData)
      console.tron.log('fileUploadRes', fileUploadRes)
    }))
  }
}

export async function postRevisaoInOikos(files, produto={}) {
  if (files.length > 0) {
    await Promise.all(files.map(async file => {
      // Cria um registro na tabela de documentos para cada arquivo
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: 30,
          documento_desc: `Revisão do produto ${produto.prod_desc}`,
          documento_iniVig: undefined,
          documento_fimVig: undefined,
          documento_dtEmissao: undefined,
          documento_prazo: undefined,
          documento_ref: undefined,
          privacidade_id: 2,
        },
      }
      const documentCreated = await oikosApi.post('/', documentBody)

      // Cria uma vinculação entre o documento (anexo) e o registro da minuta
      if (documentCreated.data[0].documento_id) {
        const vinculationBody = {
          action: 'insert',
          table: 'documentoVinc',
          data: {
            documento_id: documentCreated.data[0].documento_id,
            documentoVinc_tabRef: 'prod',
            documentoVinc_tabId: produto.prod_id,
          },
        }
        await oikosApi.post('/', vinculationBody)
      }

      // Faz upload do arquivo e registra na tabela 'arquivo'
      const formData = new FormData()
      formData.append('file', new Blob([file.arquivo[0].data], { type: file.arquivo[0].data.type }), file.arquivo[0].data.path)
      formData.append('table', 'arquivo')
      formData.append('action', 'upload_file')
      formData.append('arquivo_tabRef', 'documento')
      formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
      formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
      formData.append('arquivo_desc', file.arquivo[0].data.path)
      const fileUploadRes = await oikosApi.post('/', formData)
      console.tron.log('fileUploadRes', fileUploadRes)
    }))
  }
}

export async function postProdFinalPdfInOikos(files, produto={}) {

  if (files.length > 0) {
    await Promise.all(files.map(async file => {
      // Cria um registro na tabela de documentos para cada arquivo
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: 23,
          documento_desc: `${produto.prod_desc}`,
          documento_iniVig: undefined,
          documento_fimVig: undefined,
          documento_dtEmissao: undefined,
          documento_prazo: undefined,
          documento_ref: undefined,
          privacidade_id: 2,
        },
      }
      const documentCreated = await oikosApi.post('/', documentBody)

      // Cria uma vinculação entre o documento (anexo) e o registro da minuta
      if (documentCreated.data[0].documento_id) {
        const vinculationBody = {
          action: 'insert',
          table: 'documentoVinc',
          data: {
            documento_id: documentCreated.data[0].documento_id,
            documentoVinc_tabRef: 'prod',
            documentoVinc_tabId: produto.prod_id,
          },
        }
        await oikosApi.post('/', vinculationBody)
      }

      // Faz upload do arquivo e registra na tabela 'arquivo'
      const formData = new FormData()
      formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
      formData.append('table', 'arquivo')
      formData.append('action', 'upload_file')
      formData.append('arquivo_tabRef', 'documento')
      formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
      formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
      formData.append('arquivo_desc', file.data.path)
      const fileUploadRes = await oikosApi.post('/', formData)
      console.tron.log('fileUploadRes', fileUploadRes)
    }))
  }
}

export const getFilesFromProdutosFinais = async (linkPastaProduto) => {

  try {

    const zip = new JSZip();

    const base64Encoded = btoa(linkPastaProduto);

    const encoded = base64Encoded
    .replace(/\+/g, '-')   // base64 → base64url
    .replace(/\//g, '_')
    .replace(/=+$/g, '');  // remove padding

    const productFolder = await graphClient.api(`/shares/u!${encoded}/driveItem`).get();

    const targetUser = await graphClient.api(`/users/admin@ecossis.com.br`).get();
    const targetDriveId = targetUser.id;

    // Step 2: List all items in the specified folder
    const itemsInFolder = await graphClient.api(`/users/${targetDriveId}/drive/items/${productFolder.id}/children`).get();

    console.log(itemsInFolder);

    for (const item of itemsInFolder.value) {
      if (item.file) {
        console.log('entrou no for item of itemInFolder.value');

        const fileContent = await graphClient
          .api(`/users/${targetDriveId}/drive/items/${item.id}/content`)
          .responseType('arraybuffer')
          .get();

          console.log('capturou o fileContent em um Array Buffer');

        zip.file(item.name, fileContent);
        console.log('criou o zip');

      }
    }

    const zipContent = await zip.generateAsync({ type: 'blob' });

    console.log(zipContent);

    return zipContent;

  } catch (error) {
    console.error('Error creating the zip file:', error);
  }
};

export const saveProdFinalZipInOikos = async (zip, produto={}) => {
  if (zip) {
    // Cria um registro na tabela de documentos para cada arquivo
    const documentBody = {
      action: 'insert',
      table: 'documento',
      data: {
        tpDocumento_id: 23,
        documento_desc: `${produto.prod_desc}`,
        documento_iniVig: undefined,
        documento_fimVig: undefined,
        documento_dtEmissao: undefined,
        documento_prazo: undefined,
        documento_ref: undefined,
        privacidade_id: 2,
      },
    }
    const documentCreated = await oikosApi.post('/', documentBody)

    // Cria uma vinculação entre o documento (anexo) e o registro da minuta
    if (documentCreated.data[0].documento_id) {
      const vinculationBody = {
        action: 'insert',
        table: 'documentoVinc',
        data: {
          documento_id: documentCreated.data[0].documento_id,
          documentoVinc_tabRef: 'prod',
          documentoVinc_tabId: produto.prod_id,
        },
      }
      await oikosApi.post('/', vinculationBody)
    }

    // Faz upload do arquivo e registra na tabela 'arquivo'

    const formData = new FormData()
    formData.append('file', zip, 'produto.zip')
    formData.append('table', 'arquivo')
    formData.append('action', 'upload_file')
    formData.append('arquivo_tabRef', 'documento')
    formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
    formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
    formData.append('arquivo_desc', produto.prod_desc)
    const fileUploadRes = await oikosApi.post('/', formData)

    console.log('fileUploadRes', fileUploadRes)
    const arquivo = parseUploadArquivo(fileUploadRes)
    if (!arquivo?.arquivo_caminho) {
      console.log('upload_file não gravou arquivo (limite PHP ou resposta inválida)')
      return null
    }
    return arquivo.arquivo_caminho
  } else {
    console.log('não há zip')
    return null
  }
  /*
  try {
    const response = await fetch('http://104.198.77.243/testeEncryption2.php', {
      method: 'POST',
      body: formData,
    });

    const result = await response.json();
    console.log('Response from PHP:', result);

  } catch (error) {
    console.error('Error sending files to PHP:', error);
  }
  */
}

export async function verificaPastaProdFinal(linkPastaProduto) {
  try {
    const base64Encoded = btoa(linkPastaProduto);

    const encoded = base64Encoded
    .replace(/\+/g, '-')   // base64 → base64url
    .replace(/\//g, '_')
    .replace(/=+$/g, '');  // remove padding

    const productFolder = await graphClient.api(`/shares/u!${encoded}/driveItem`).get();

    const targetUser = await graphClient.api(`/users/admin@ecossis.com.br`).get();
    const targetDriveId = targetUser.id;

    // Step 2: List all items in the specified folder
    const itemsInFolder = await graphClient.api(`/users/${targetDriveId}/drive/items/${productFolder.id}/children`).get();

    if (itemsInFolder.value.length > 0) {
      return true;
    } else {
      notifyError('A pasta do produto final no OneDrive está vazia.')
      return false;
    }
  } catch (error) {
    console.error('err', error)
    notifyError('Erro ao verificar pasta do produto final no OneDrive.')
    return false;
  }
}

export async function getLinkProdFinal(prod_id) {
  const docsVinculadosProd = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'documentoVinc',
    data: {
      documentoVinc_tabRef: 'prod',
      documentoVinc_tabId: prod_id
    },
    fields: {
      '(SELECT arquivo.arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 23 AND doc.documento_id = documentoVinc.documento_id))': 'linkProdFinal',
    }
  })}`)

  const arrayProdFinaisComLink = docsVinculadosProd.data.filter((doc => doc.linkProdFinal))

  const linksArquivosProdsFinais = arrayProdFinaisComLink.map(arquivo => arquivo.linkProdFinal);

  if (linksArquivosProdsFinais.length === 0) {
    return null;
  }

  return linksArquivosProdsFinais;
}

export async function getLinkEvidencia(prod_id) {
  const docsVinculadosProd = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'documentoVinc',
    data: {
      documentoVinc_tabId: prod_id
    },
    fields: {
      '(SELECT arquivo.arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 24 AND doc.documento_id = documentoVinc.documento_id))': 'linkEvidencia',
    }
  })}`)

  const arrayPareceresComLink = docsVinculadosProd.data.filter((doc => doc.linkEvidencia))

  if (arrayPareceresComLink.length === 0) {
    return null;
  }

  const linksPareceres = arrayPareceresComLink.map(arquivo => arquivo.linkEvidencia);

  return linksPareceres;
}

export async function getLinkDocumentoDeCobranca(bdro_id) {
  const docsVinculadosBoleto = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'documentoVinc',
    data: {
      documentoVinc_tabRef: 'bdro',
      documentoVinc_tabId: bdro_id
    },
    fields: {
      documento_id: 'documento_id',
      '(SELECT arquivo.arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 29 AND doc.documento_id = documentoVinc.documento_id) ORDER BY arquivo_id DESC LIMIT 1)': 'linkBoleto',
    }
  })}`)

  console.log('docsVinculadosBoleto', docsVinculadosBoleto);

  const arrayBoletosComLink = (docsVinculadosBoleto.data || [])
    .filter((doc) => doc.linkBoleto)
    .sort((a, b) => Number(a.documento_id || 0) - Number(b.documento_id || 0))

  console.log('arrayBoletosComLink', arrayBoletosComLink);

  if (arrayBoletosComLink.length === 0) {
    return [];
  }

  const linksBoletos = arrayBoletosComLink.map(arquivo => arquivo.linkBoleto);

  return linksBoletos;

}

export async function getLinksDocumentoDeRevisaoInterna(prod_id) {
  const docsVinculadosProd = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'documentoVinc',
    data: {
      documentoVinc_tabId: prod_id
    },
    fields: {
      '(SELECT arquivo.arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 30 AND doc.documento_id = documentoVinc.documento_id))': 'linkDocumentoRevisao',
    }
  })}`)

  const arrayDocumentosRevisaoComLink = docsVinculadosProd.data.filter((doc => doc.linkDocumentoRevisao))

  const linksDocumentosRevisao = arrayDocumentosRevisaoComLink.map(arquivo => arquivo.linkDocumentoRevisao);

  if (linksDocumentosRevisao.length === 0) {
    return [];
  }

  return linksDocumentosRevisao;

}

export async function getLinkNotaFiscal(bdro_id) {
  const docsVinculadosNotaFiscal = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'documentoVinc',
    data: {
      documentoVinc_tabRef: 'bdro',
      documentoVinc_tabId: bdro_id
    },
    fields: {
      documento_id: 'documento_id',
      '(SELECT arquivo.arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 27 AND doc.documento_id = documentoVinc.documento_id) ORDER BY arquivo_id DESC LIMIT 1)': 'linkNotaFiscal',
    }
  })}`)

  const arrayNotaFiscalComLink = (docsVinculadosNotaFiscal.data || [])
    .filter((doc) => doc.linkNotaFiscal)
    .sort((a, b) => Number(a.documento_id || 0) - Number(b.documento_id || 0))

  if (arrayNotaFiscalComLink.length === 0) {
    return [];
  }

  const linkNotaFiscal = arrayNotaFiscalComLink.map(arquivo => arquivo.linkNotaFiscal);

  return linkNotaFiscal;

}

export async function getLinkComprovante(bdro_id) {
  const docsVinculadosComprovante = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'documentoVinc',
    data: {
      documentoVinc_tabRef: 'bdro',
      documentoVinc_tabId: bdro_id
    },
    fields: {
      documento_id: 'documento_id',
      '(SELECT arquivo.arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 28 AND doc.documento_id = documentoVinc.documento_id) ORDER BY arquivo_id DESC LIMIT 1)': 'linkComprovante',
    }
  })}`)

  const arrayComprovanteComLink = (docsVinculadosComprovante.data || [])
    .filter((doc) => doc.linkComprovante)
    .sort((a, b) => Number(a.documento_id || 0) - Number(b.documento_id || 0))

  if (arrayComprovanteComLink.length === 0) {
    return [];
  }

  const linkComprovante = arrayComprovanteComLink.map(arquivo => arquivo.linkComprovante);

  return linkComprovante;
}

const MAX_OIKOS_UPLOAD_BYTES = 2 * 1024 * 1024

function parseUploadArquivo(uploadRes) {
  if (Array.isArray(uploadRes?.data) && uploadRes.data[0]?.arquivo_caminho) {
    return uploadRes.data[0]
  }
  const resStr = typeof uploadRes?.data === 'string'
    ? uploadRes.data
    : JSON.stringify(uploadRes?.data ?? '')
  const match = resStr.match(/\[\{"arquivo_id".*?\}\]/)
  if (!match) return null
  try {
    const parsed = JSON.parse(match[0])
    return parsed?.[0] || null
  } catch (e) {
    return null
  }
}

function toProdFinalHref(pathOrUrl) {
  if (!pathOrUrl) return null
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl
  return `https://oikos.ecoss.is/oikos/${String(pathOrUrl).replace(/^\//, '')}`
}

function encodeShareUrl(linkPastaProduto) {
  return btoa(linkPastaProduto)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '')
}

export async function criaLinkVisualizacaoPastaProdFinal(linkPastaProduto) {
  try {
    const productFolder = await graphClient.api(`/shares/u!${encodeShareUrl(linkPastaProduto)}/driveItem`).get()
    const targetUser = await graphClient.api('/users/admin@ecossis.com.br').get()
    const criaLink = await graphClient
      .api(`/users/${targetUser.id}/drive/items/${productFolder.id}/createLink`)
      .post({ type: 'view', scope: 'anonymous' })
    return criaLink?.link?.webUrl || null
  } catch (error) {
    console.error('Erro ao criar link de visualização da pasta do produto', error)
    return null
  }
}

export async function getProdFinalDownloadHref(produto = {}, linksJaCarregados) {
  const caminhos = Array.isArray(linksJaCarregados) ? linksJaCarregados.filter(Boolean) : []
  if (caminhos.length > 0) {
    return toProdFinalHref(caminhos[caminhos.length - 1])
  }

  const fetched = await getLinkProdFinal(produto.prod_id)
  if (Array.isArray(fetched) && fetched.length > 0) {
    return toProdFinalHref(fetched[fetched.length - 1])
  }

  const pastaOk = await verificaPastaProdFinal(produto.prod_drive)
  if (!pastaOk) return null

  const zip = await getFilesFromProdutosFinais(produto.prod_drive)
  if (zip && zip.size <= MAX_OIKOS_UPLOAD_BYTES) {
    const caminho = await saveProdFinalZipInOikos(zip, produto)
    if (caminho) return toProdFinalHref(caminho)
  } else if (zip) {
    console.log('Zip do produto final excede o limite de upload do PHP', zip.size)
  }

  return criaLinkVisualizacaoPastaProdFinal(produto.prod_drive)
}

export const getZipAndSaveInOikos = async (prod_drive, produto) => {

  try {
    const productZip = await getFilesFromProdutosFinais(prod_drive);

    const saveZip = await saveProdFinalZipInOikos(productZip, produto)

    console.log(productZip);
    console.log(saveZip);
    return saveZip

  } catch (error) {
    console.error('Error downloading the zip file:', error);
  }
};

// Function to download the file with a custom name
export const downloadFile = async (url, filename) => {
  const response = await fetch(url);
  const blob = await response.blob();

  // Create a link element, set it to download the blob
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = filename; // Set the desired file name
  link.click(); // Trigger the download
};

// Notify if a product was updated
export const notifyProductUpdating = async (prod, diffKeys) => {

  function printStandardEmail(content) {
    return `
    <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
              body {
                  font-family: Arial, sans-serif;
                  color: #273351; /* Cor principal da marca */
                  margin: 0;
                  padding: 0;
                  background-color: #f4f4f4;
              }
              .container {
                  width: 120%;
                  max-width: 700px;
                  margin: 50 auto;
                  background-color: #ffffff;
                  padding: 20px;
                  border-radius: 5px;
                  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
              }
              .header {
                  text-align: center;
                  padding-bottom: 20px;
              }
              .header img {
                  max-width: 150px;
              }
              .content {
                  font-size: 16px;
                  line-height: 1.6;
                  color: #273351;
              }
              .content p {
                  margin-bottom: 20px;
              }
              .footer {
                  text-align: center;
                  padding-top: 20px;
                  font-size: 14px;
                  color: #999999;
              }
              .footer a {
                  color: #273351;
                  text-decoration: none;
              }
              .footer img {
                  max-width: 90%;
                  height: auto;
                  margin-top: 20px;
              }
      </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <img src="https://ecossis.com/www1/wp-content/uploads/2024/08/Design-sem-nome-11.png" alt="Ecossis Logo">
          </div>
          <div class="content">
            ${content}
          </div>
          <div class="footer">
            <p>&copy; 2024 Ecossis Soluções Ambientais. Todos os direitos reservados.</p>
            <p>Visite nosso site: <a href="https://www.ecossis.com" target="_blank">www.ecossis.com</a></p>
            <img src="https://ecossis.com/www1/wp-content/uploads/2024/08/Ass_2024_2.png" alt="Imagem de Assinatura">
          </div>
        </div>
      </body>
    </html>
  `
  }

  let diffKeysDescription = ``;
  let campo = ``;

  for (const key in diffKeys) {
    if (key === 'prod_responsavel') {
      // Skip prod_responsavel, we don't want to include this
      continue;
    }

    switch (key) {
      case 'prod_dtContrato':
        campo = 'Data contratual';
        break;
      case 'prod_dtInterna':
        campo = 'Data prevista';
        break;
      case 'prod_dtEntrega':
        campo = 'Data de entrega';
        break;
      case 'prod_dtAprov':
        campo = 'Data de aprovação';
        break;
      case 'prod_dtLimAprov':
        campo = 'Data limite de aprovação';
        break;
      case 'prod_responsavelNome':
        campo = 'Responsável';
        break;
      default:
        // If none of the above keys match, skip adding anything
        campo = '';
        break;
    }

    if (campo) {
      diffKeysDescription = diffKeysDescription + `
        ${campo} mudou de <strong>${diffKeys[key]["previousData"]}</strong> para <strong>${diffKeys[key]["updatedData"]}</strong><br/>
      `;
    }

    // Specifically handle prod_dtMod outside the switch case
    if (key === 'prod_dtMod') {
      diffKeysDescription = diffKeysDescription + `
        Data da modificação: <strong>${diffKeys[key]["updatedData"]}</strong><br/>
      `;
    }
  }

  await sendEmailToNotify(
    'pedro.gasparotto@ecossis.com.br',
    `Alteração no produto ${prod.prod_desc}`,
    printStandardEmail(
      `
        <strong>O produto ${prod.prod_desc} foi alterado.</strong><br/>
        <br/>
        <span>Os seguintes dados foram atualizados:</span><br/>
        ${diffKeysDescription}
      `
    ),
    '')
}

export async function saveBoleto(boletoFile, bdroRecord) {
        // Cria um registro na tabela de documentos para cada arquivo
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: 29,
            documento_desc: `Boleto do produto ${boletoFile.arquivo.path}`,
            documento_iniVig: undefined,
            documento_fimVig: undefined,
            documento_dtEmissao: undefined,
            documento_prazo: undefined,
            documento_ref: undefined,
            privacidade_id: 2,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        // Cria uma vinculação entre o documento (anexo) e o registro da minuta
        if (documentCreated.data[0].documento_id) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'bdro',
              documentoVinc_tabId: bdroRecord.bdro_id,
            },
          }
          await oikosApi.post('/', vinculationBody)
        }

        // Faz upload do arquivo e registra na tabela 'arquivo'
        const formData = new FormData()
        formData.append('file', new Blob([boletoFile.arquivo], { type: boletoFile.arquivo.type }), boletoFile.arquivo.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', boletoFile.arquivo.path)
        const fileUploadRes = await oikosApi.post('/', formData)
        console.tron.log('fileUploadRes', fileUploadRes)
}

export async function saveComprovantePagamento(comprovanteFile, bdroRecord) {
  // Cria um registro na tabela de documentos para cada arquivo

  console.log(comprovanteFile)

  const documentBody = {
    action: 'insert',
    table: 'documento',
    data: {
      tpDocumento_id: 28,
      documento_desc: `Comprovante de Pagamento ${comprovanteFile.arquivo.path}`,
      documento_iniVig: undefined,
      documento_fimVig: undefined,
      documento_dtEmissao: undefined,
      documento_prazo: undefined,
      documento_ref: undefined,
      privacidade_id: 2,
    },
  }
  const documentCreated = await oikosApi.post('/', documentBody)

  // Cria uma vinculação entre o documento (anexo) e o registro da minuta
  if (documentCreated.data[0].documento_id) {
    const vinculationBody = {
      action: 'insert',
      table: 'documentoVinc',
      data: {
        documento_id: documentCreated.data[0].documento_id,
        documentoVinc_tabRef: 'bdro',
        documentoVinc_tabId: bdroRecord.bdro_id,
      },
    }
    await oikosApi.post('/', vinculationBody)
  }

  // Faz upload do arquivo e registra na tabela 'arquivo'
  const formData = new FormData()
  formData.append('file', new Blob([comprovanteFile.arquivo], { type: comprovanteFile.arquivo.type }), comprovanteFile.arquivo.path)
  formData.append('table', 'arquivo')
  formData.append('action', 'upload_file')
  formData.append('arquivo_tabRef', 'documento')
  formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
  formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
  formData.append('arquivo_desc', comprovanteFile.arquivo.path)
  const fileUploadRes = await oikosApi.post('/', formData)
  console.tron.log('fileUploadRes', fileUploadRes)
}

export async function saveNotaFiscal(notaFiscalFile, bdroRecord) {
  // Cria um registro na tabela de documentos para cada arquivo
  const documentBody = {
    action: 'insert',
    table: 'documento',
    data: {
      tpDocumento_id: 27,
      documento_desc: `Nota Fiscal ${notaFiscalFile.arquivo.path}`,
      documento_iniVig: undefined,
      documento_fimVig: undefined,
      documento_dtEmissao: undefined,
      documento_prazo: undefined,
      documento_ref: undefined,
      privacidade_id: 2,
    },
  }
  const documentCreated = await oikosApi.post('/', documentBody)

  // Cria uma vinculação entre o documento (anexo) e o registro da minuta
  if (documentCreated.data[0].documento_id) {
    const vinculationBody = {
      action: 'insert',
      table: 'documentoVinc',
      data: {
        documento_id: documentCreated.data[0].documento_id,
        documentoVinc_tabRef: 'bdro',
        documentoVinc_tabId: bdroRecord.bdro_id,
      },
    }
    await oikosApi.post('/', vinculationBody)
  }

  // Faz upload do arquivo e registra na tabela 'arquivo'
  const formData = new FormData()
  formData.append('file', new Blob([notaFiscalFile.arquivo], { type: notaFiscalFile.arquivo.type }), notaFiscalFile.arquivo.path)
  formData.append('table', 'arquivo')
  formData.append('action', 'upload_file')
  formData.append('arquivo_tabRef', 'documento')
  formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
  formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
  formData.append('arquivo_desc', notaFiscalFile.arquivo.path)
  const fileUploadRes = await oikosApi.post('/', formData)
  console.tron.log('fileUploadRes', fileUploadRes)
}

export async function saveAnexosContaAPagar(files, bdroRecord) {
  console.log('Entrou no saveAnexos')
  if (files.find(item => item.tipo === 'documento de cobranca')) {
    console.log('Entrou no find documento de cobranca');
    await saveBoleto(files.find(item => item.tipo === 'documento de cobranca'), bdroRecord)
  }
  if (files.find(item => item.tipo === 'comprovante')) {
    console.log('Entrou no find comprovante');
    await saveComprovantePagamento(files.find(item => item.tipo === 'comprovante'), bdroRecord)
  }
  if (files.find(item => item.tipo === 'nota fiscal')) {
    console.log('Entrou no find nota fiscal');
    await saveNotaFiscal(files.find(item => item.tipo === 'nota fiscal'), bdroRecord)
  } else {
    console.log('Preencha todos os campos de anexos')
  }
}

export function parseCurrencyToNumber(currencyString) {
  // Remove any non-numeric characters except for comma and dot
  let cleanedString = currencyString.replace(/[^\d,.-]/g, '');
  // Replace comma with dot for decimal point
  cleanedString = cleanedString.replace(/\./g, '').replace(',', '.');
  // Parse as a float
  const numberValue = parseFloat(cleanedString);

  return isNaN(numberValue) ? 0 : numberValue;
}

export const notifyExceedingBordero = async (bdroInfo) => {

  function printStandardEmail(content) {
    return `
    <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
              body {
                  font-family: Arial, sans-serif;
                  color: #273351; /* Cor principal da marca */
                  margin: 0;
                  padding: 0;
                  background-color: #f4f4f4;
              }
              .container {
                  width: 120%;
                  max-width: 700px;
                  margin: 50 auto;
                  background-color: #ffffff;
                  padding: 20px;
                  border-radius: 5px;
                  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
              }
              .header {
                  text-align: center;
                  padding-bottom: 20px;
              }
              .header img {
                  max-width: 150px;
              }
              .content {
                  font-size: 16px;
                  line-height: 1.6;
                  color: #273351;
              }
              .content p {
                  margin-bottom: 20px;
              }
              .footer {
                  text-align: center;
                  padding-top: 20px;
                  font-size: 14px;
                  color: #999999;
              }
              .footer a {
                  color: #273351;
                  text-decoration: none;
              }
              .footer img {
                  max-width: 90%;
                  height: auto;
                  margin-top: 20px;
              }
      </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <img src="https://ecossis.com/www1/wp-content/uploads/2024/08/Design-sem-nome-11.png" alt="Ecossis Logo">
          </div>
          <div class="content">
            ${content}
          </div>
          <div class="footer">
            <p>&copy; 2024 Ecossis Soluções Ambientais. Todos os direitos reservados.</p>
            <p>Visite nosso site: <a href="https://www.ecossis.com" target="_blank">www.ecossis.com</a></p>
            <img src="https://ecossis.com/www1/wp-content/uploads/2024/08/Ass_2024_2.png" alt="Imagem de Assinatura">
          </div>
        </div>
      </body>
    </html>
  `
  }

  await sendEmailToNotify(
    'diretoria.tecnica@ecossis.com.br',
    `Solicitação de pagamento excedendo valor`,
    printStandardEmail(
      `
        <span>Solicitação <strong>${bdroInfo.desc}</strong> está excedendo o valor planejado.</span><br/>
        <br/>
        Valor previsto: ${currencyFormatter.format(bdroInfo.orcamentoInfoMes.emOrcDot || 0)}<br/>
        Valor solicitado: ${currencyFormatter.format(bdroInfo.valor)}<br/>
        Valor já solicitado com este item: ${currencyFormatter.format(bdroInfo.orcamentoInfoMes.jaNoBordero)}<br/>
      `
    ),
    '')

  await sendEmailToNotify(
    'gerente.tecnico@ecossis.com.br',
    `Solicitação de pagamento excedendo valor`,
    printStandardEmail(
      `
        <span>Solicitação <strong>${bdroInfo.desc}</strong> está excedendo o valor planejado.</span><br/>
        <br/>
        Valor previsto: ${currencyFormatter.format(bdroInfo.orcamentoInfoMes.emOrcDot || 0)}<br/>
        Valor solicitado: ${currencyFormatter.format(bdroInfo.valor)}<br/>
        Valor já solicitado com este item: ${currencyFormatter.format(bdroInfo.orcamentoInfoMes.jaNoBordero)}<br/>
      `
    ),
    '')
}

export const notifyBordero = async (bdroInfo) => {

  await sendEmailToNotify(
    'diretoria.tecnica@ecossis.com.br',
    `Solicitação de pagamento`,
    printStandardEmail(
      `
        <span>Solicitação de pagamento <strong>${bdroInfo.desc}</strong>.</span><br/>
        <br/>
        Valor previsto: ${currencyFormatter.format(bdroInfo.orcamentoInfoMes.emOrcDot || 0)}<br/>
        Valor solicitado: ${currencyFormatter.format(bdroInfo.valor)}<br/>
        Valor já solicitado com este item: ${currencyFormatter.format(bdroInfo.orcamentoInfoMes.jaNoBordero)}<br/>
      `
    ),
    '')

  await sendEmailToNotify(
    'gerente.tecnico@ecossis.com.br',
    `Solicitação de pagamento`,
    printStandardEmail(
      `
        <span>Solicitação de pagamento <strong>${bdroInfo.desc}</strong>.</span><br/>
        <br/>
        Valor previsto: ${currencyFormatter.format(bdroInfo.orcamentoInfoMes.emOrcDot || 0)}<br/>
        Valor solicitado: ${currencyFormatter.format(bdroInfo.valor)}<br/>
        Valor já solicitado com este item: ${currencyFormatter.format(bdroInfo.orcamentoInfoMes.jaNoBordero)}<br/>
      `
    ),
    '')
}

export const taskManager = async (orcItem) => {

  const taskBodyMother = {
    action: 'insert',
    table: 'task',
    data: {
      task_desc: `Suplementação para ${orcItem}`,
      pf_id: 141,
      task_usuarioCria: 141,
      task_usuarioMod: 141,
    }
  }

  const taskMotherCreated = await oikosApi.post('/', taskBodyMother);

  const taskBody = {
    action: 'insert',
    table: 'task',
    data: {
      task_desc: `Suplementação para ${orcItem}`,
      task_mae: taskMotherCreated.data[0].task_id,
      pf_id: 141,
      task_usuarioCria: 141,
      task_usuarioMod: 141,
    }
  }

  const taskCreated = await oikosApi.post('/', taskBody);

  console.log(taskMotherCreated);
  console.log(taskCreated);
}

export async function createProductFolder(targetUserEmail, nomeProjeto) {
  try {
    // Step 1: Check if the parent folder exists and get its ID
    console.log(`Target User Email: ${targetUserEmail}`);

    const targetUser = await graphClient.api(`/users/${targetUserEmail}`).get();

    console.log(`Target User: `, targetUser);

    const targetDriveId = targetUser.id;
    const pastaAlvoId = '01QIA2577NCVZTIHQ27JELEOMZEZLLOA7P';

    console.log(`Target Drive ID: ${targetDriveId}`);

    const parentFolder = {
      name: nomeProjeto,
      folder: {},
      '@microsoft.graph.conflictBehavior': 'rename',
    };

    const getPastaAlvo = await graphClient.api(`/users/${targetDriveId}/drive/items/${pastaAlvoId}/children`).get();

    const listaPastasEmProjetos = getPastaAlvo.value;

    const folderExists = listaPastasEmProjetos.some(pasta => pasta.name === nomeProjeto && pasta.folder);

    console.log(folderExists);

    if (!folderExists) {
      const parentFolderResponse = await graphClient.api(`/users/${targetDriveId}/drive/items/${pastaAlvoId}/children`)
        .header('Content-Type', 'application/json')
        .post(parentFolder);

      const foldersToCreate = [
        { name: `1 - ART`, folder: {} },
        { name: `2 - Contrato`, folder: {} },
        { name: `3 - TR`, folder: {} },
        { name: `4 - Documentos do Cliente`, folder: {} },
        { name: `5 - Gestão`, folder: {} },
        { name: `6 - Produção`, folder: {} },
        { name: `7 - Produtos Finais`, folder: {} },
      ];

      // Create the folders inside the parent folder
      for (const folder of foldersToCreate) {
        const folderResponse = await graphClient.api(`/users/${targetDriveId}/drive/items/${parentFolderResponse.id}/children`)
          .header('Content-Type', 'application/json')
          .post(folder);

      }

      console.tron.log('Products folders created successfully');
    } else {
      console.log('Pasta não foi criada pois esse nome já existe.');
      return;
    }
  } catch (err) {
    console.tron.log('Error creating product folder: ', err);
  }
}

export async function createProductsFoldersInProdutosFinais(idProjeto, nomeProjeto) {
    //Acessa o BD e pega a lista de todos os produtos com proj_id = idProjeto
    const listaProdutos = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prod',
      data: {
        proj_id: idProjeto, // here you need the proj_id
        prod_ativo: 1,
      },
      fields: {
      },
    })}`)

    const foldersToCreate = [];

    for (const product of listaProdutos.data) {
      const productInfo = {
        folderInfo: {name: product.prod_desc, folder: {}},
        prod_id: product.prod_id
      };

      foldersToCreate.push(productInfo);
    }

    //Pega a pasta Projetos
    const targetUserEmail = 'admin@ecossis.com.br'

    console.log(`Target User Email: ${targetUserEmail}`);

    const targetUser = await graphClient.api(`/users/${targetUserEmail}`).get();

    console.log(`Target User: `, targetUser);

    const targetDriveId = targetUser.id;
    const pastaAlvoId = '01QIA2577NCVZTIHQ27JELEOMZEZLLOA7P';

    const getPastaAlvo = await graphClient.api(`/users/${targetDriveId}/drive/items/${pastaAlvoId}/children`).get();

  //Pega a pasta com o nome do Projeto
  const projectFolder = getPastaAlvo.value.find(
    (item) => item.name === nomeProjeto && item.folder
  );

  const getProjectFolder = await graphClient.api(`/users/${targetDriveId}/drive/items/${projectFolder.id}/children`).get();

  for (const folder of getProjectFolder.value) {

    //pega a pasta com o nome "7 - Produtos Finais"
    if (folder.name === '7 - Produtos Finais') {

      //dentro da pasta "7 - Produtos Finais", cria uma pasta para cada produto na lista de produtos que veio do BD.
      for (const productFolder of foldersToCreate) {
        const productFolderResponse = await graphClient.api(`/users/${targetDriveId}/drive/items/${folder.id}/children`)
          .header('Content-Type', 'application/json')
          .post(productFolder.folderInfo);

        const produtoSharingLinkResponse = await graphClient.api(`/users/${targetDriveId}/drive/items/${productFolderResponse.id}/createLink`)
          .header('Content-Type', 'application/json')
          .post({
            type: 'view',
            scope: 'organization',
          });

        update('prod', productFolder.prod_id, {prod_drive: produtoSharingLinkResponse.link.webUrl} );
      }
    }
  }

  if (getProjectFolder) {
    console.log('Found folder:', getProjectFolder);
  } else {
    console.log('Project folder not found');
  }
}

export async function createProductsFoldersInProducao(idProjeto, nomeProjeto) {
    //Acessa o BD e pega a lista de todos os produtos com proj_id = idProjeto
    const listaProdutos = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prod',
      data: {
        proj_id: idProjeto, // here you need the proj_id
        prod_ativo: 1,
      },
      fields: {
      },
    })}`)

    const foldersToCreate = [];

    for (const product of listaProdutos.data) {
      const productInfo = {
        folderInfo: {name: product.prod_desc, folder: {}},
        prod_id: product.prod_id
      };

      foldersToCreate.push(productInfo);
    }

    //Pega a pasta Projetos
    const targetUserEmail = 'admin@ecossis.com.br'

    console.log(`Target User Email: ${targetUserEmail}`);

    const targetUser = await graphClient.api(`/users/${targetUserEmail}`).get();

    console.log(`Target User: `, targetUser);

    const targetDriveId = targetUser.id;
    const pastaAlvoId = '01QIA2577NCVZTIHQ27JELEOMZEZLLOA7P';

    const getPastaAlvo = await graphClient.api(`/users/${targetDriveId}/drive/items/${pastaAlvoId}/children`).get();

  //Pega a pasta com o nome do Projeto
  const projectFolder = getPastaAlvo.value.find(
    (item) => item.name === nomeProjeto && item.folder
  );

  const getProjectFolder = await graphClient.api(`/users/${targetDriveId}/drive/items/${projectFolder.id}/children`).get();

  for (const folder of getProjectFolder.value) {

    //pega a pasta com o nome "6 - Produção"
    if (folder.name === '6 - Produção') {

      //dentro da pasta "6 - Produção", cria uma pasta para cada produto na lista de produtos que veio do BD.
      for (const productFolder of foldersToCreate) {
        const productFolderResponse = await graphClient.api(`/users/${targetDriveId}/drive/items/${folder.id}/children`)
          .header('Content-Type', 'application/json')
          .post(productFolder.folderInfo);
      }
    }
  }

  if (getProjectFolder) {
    console.log('Found folder:', getProjectFolder);
  } else {
    console.log('Folder "ProjectA" not found');
  }

}

export async function getReceitasFromOikos() {
  const receitas = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'rec',
    data: {
      rec_ativo: 1,
    },
    fields: {
      "(SELECT IFNULL((SELECT proj_nome FROM proj WHERE proj.orcRubr_id = rec.orcRubr_id AND proj.proj_ativo = 1 LIMIT 1), 'SEM PROJETO'))": 'recProjeto',
      "(SELECT IFNULL(NULLIF(TRIM(pj.pj_razaosocial), ''), pj.pj_nomefanta) FROM pj WHERE pj.pj_id = rec.pj_tomador LIMIT 1)": 'pjTomadorNome',
      "(SELECT pj.kamino_id FROM pj WHERE pj.pj_id = rec.pj_tomador LIMIT 1)": 'pjTomadorKaminoId',
      "(SELECT IFNULL(NULLIF(TRIM(pj.pj_razaosocial), ''), pj.pj_nomefanta) FROM pj WHERE pj.pj_id = rec.pj_prestador LIMIT 1)": 'pjPrestadorNome',
      "(SELECT pj.kamino_id FROM pj WHERE pj.pj_id = rec.pj_prestador LIMIT 1)": 'pjPrestadorKaminoId',
    }
  })}`)

  return receitas.data;
}

export async function getProductsFromOikosToGrid(arrayDates) {

  const todosProdutos = [];
  let lengthMap = arrayDates.length;

  while (true) {
    if (lengthMap > 300) {
      let lengthSlice = lengthMap - 300;
      let sliceArrayDates = arrayDates.slice(lengthSlice, lengthMap);

      let in_txt = '';

      for (const date of sliceArrayDates) {
        in_txt += `'${date}',`
      }

      const produtos = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'prod',
        data: {
          prod_ativo: 1,
          prod_dtInterna: `!IN!(SELECT prod_dtInterna FROM prod WHERE prod.prod_ativo = 1 AND prod.prod_dtInterna IN (${in_txt.slice(0, -1)}))`,
        },
        fields: {
          "(SELECT pfCoord.pf_emailProf FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavel_email",

  "(SELECT pfCoord.pf_nomeExibicao FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod_PROD_ID AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavelNome",
    '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavelNomeAtual',
    '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavel_email_atual',
          "(SELECT prodStatusTp_nome FROM prodStatusTp WHERE prodStatusTp.prodStatusTp_id = prod.prodStatusTp_id)":
            "prodStatusTp_nome",
          "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)":
            "prodStatusActual_id",
          "(SELECT proj.projSituacao_id FROM proj WHERE proj.proj_id = prod.proj_id)":
            "projSituacao_id",
          "(SELECT proj.proj_nome FROM proj WHERE proj.proj_id = prod.proj_id)":
            "proj_nome",
          "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)":
            "prodEntregueAoClienteData",
          "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 7 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)":
            "prodAprovacaoData",
          "(SELECT DAY(prod.prod_dtInterna))": "diaRow",
        },
      })}`);

      todosProdutos.push(...produtos.data);

      console.log('produtos.data', produtos.data);
      lengthMap = lengthSlice;

    } else {
      let sliceArrayDates = arrayDates.slice(0, lengthMap);

      let in_txt = '';

      for (const date of sliceArrayDates) {
        in_txt += `'${date}',`
      }

      const produtos = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'prod',
        data: {
          prod_ativo: 1,
          prod_dtInterna: `!IN!(SELECT prod_dtInterna FROM prod WHERE prod.prod_ativo = 1 AND prod.prod_dtInterna IN (${in_txt.slice(0, -1)}))`,
        },
        fields: {
          "(SELECT pfCoord.pf_emailProf FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavel_email",

  "(SELECT pfCoord.pf_nomeExibicao FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavelNome",
    '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavelNomeAtual',
    '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavel_email_atual',
          "(SELECT prodStatusTp_nome FROM prodStatusTp WHERE prodStatusTp.prodStatusTp_id = prod.prodStatusTp_id)":
            "prodStatusTp_nome",
          "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)":
            "prodStatusActual_id",
          "(SELECT proj.projSituacao_id FROM proj WHERE proj.proj_id = prod.proj_id)":
            "projSituacao_id",
          "(SELECT proj.proj_nome FROM proj WHERE proj.proj_id = prod.proj_id)":
            "proj_nome",
          "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)":
            "prodEntregueAoClienteData",
          "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 7 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)":
            "prodAprovacaoData",
        },
      })}`);

      todosProdutos.push(...produtos.data);
      console.log('produtos.data', produtos.data);

      break;
    }
  }

  const produtosEmAndamento = (todosProdutos).filter((produto) => produto.projSituacao_id === 2).sort((a, b) => {
    if (new Date(a.prod_dtInterna) < new Date(b.prod_dtInterna)) return -1;
    if (new Date(a.prod_dtInterna) > new Date(b.prod_dtInterna)) return 1;
    return 0;
  });

  console.log(produtosEmAndamento)

  return produtosEmAndamento;
}

export async function getProductsByRespId(respId) {
  if (!respId) return [];

  const produtos = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'prod',
    data: {
      prod_ativo: 1,
      prod_responsavel: respId,
    },
    fields: {
      "(SELECT pfCoord.pf_emailProf FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavel_email",

  "(SELECT pfCoord.pf_nomeExibicao FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavelNome",
    '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavelNomeAtual',
    '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavel_email_atual',
      "(SELECT prodStatusTp_nome FROM prodStatusTp WHERE prodStatusTp.prodStatusTp_id = prod.prodStatusTp_id)":
        "prodStatusTp_nome",
      "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)":
        "prodStatusActual_id",
      "(SELECT proj.projSituacao_id FROM proj WHERE proj.proj_id = prod.proj_id AND proj.proj_ativo = 1)":
        "projSituacao_id",
      "(SELECT proj.proj_nome FROM proj WHERE proj.proj_id = prod.proj_id)":
        "proj_nome",
      "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)":
        "prodEntregueAoClienteData",
      "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 7 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)":
        "prodAprovacaoData",
      "(SELECT DAY(prod.prod_dtInterna))": "diaRow",
    },
  })}`);

  const produtosEmAndamento = (produtos.data).filter((produto) => produto.projSituacao_id === 2).sort((a, b) => {
    if (new Date(a.prod_dtInterna) < new Date(b.prod_dtInterna)) return -1;
    if (new Date(a.prod_dtInterna) > new Date(b.prod_dtInterna)) return 1;
    return 0;
  });

  return produtosEmAndamento;
}

export async function getPfById(id) {

  const pf = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'pf',
    data: {
      pf_id: id,
    },
    fields: {
    },
  })}`);

  return pf.data[0];
}

export async function getPfProjectsByPfId(id) {
  if (!id) return [];

  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'projEquipe',
    data: {
      pf_id: id,
      projEquipe_ativo: 1,
    },
    fields: {
      "(SELECT proj_nome FROM proj WHERE proj.proj_id = projEquipe.proj_id AND proj.proj_ativo = 1)": "proj_nome",
      "(SELECT proj_situacao FROM proj WHERE proj.proj_id = projEquipe.proj_id AND proj.proj_ativo = 1)": "proj_situacao",
    },
  })}`);

  // Filter out any projects that returned null for proj_nome (because they are inactive or deleted)
  return Array.isArray(res.data) ? res.data.filter(p => p.proj_nome) : [];
}

export function validarCPF(cpf) {
  cpf = cpf.replace(/\D/g, ''); // Remove caracteres não numéricos
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false; // Verifica tamanho e repetição de números iguais

  let soma = 0, resto;
  // Validação do primeiro dígito
  for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) return false;

  soma = 0;
  // Validação do segundo dígito
  for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  return resto === parseInt(cpf.charAt(10));
}

export function validarCNPJ(cnpj) {
  cnpj = cnpj.replace(/\D/g, ''); // Remove caracteres não numéricos
  if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false; // Verifica tamanho e repetição de números iguais

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  // Cálculo do primeiro dígito verificador
  for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(0))) return false;

  soma = 0;
  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  pos = tamanho - 7;

  // Cálculo do segundo dígito verificador
  for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

  return resultado === parseInt(digitos.charAt(1));
}

// a função sendFormEmail deve receber um objeto (parâmetro data) que
// contenha o email do destinatário (nome da chave emailDest), nome do destinatário (nome da cheve nomeDest)
// e o link do formulário (nome da chave formLink).
// caso haja um corpo adicional para o email, adicionar na chave corpo no objeto data.
// opcionais: mensagemIntro, formLinkLabel, corpoTitulo, mensagemEncerramento
// para auditoria em emailEnvio: emailEnvioTabRef + emailEnvioTabId (obrigatórios para registrar)
export async function registerEmailEnvio({
  tabRef,
  tabId,
  destinatarioEmail,
  destinatarioNome = null,
  assunto,
  corpo = null,
  corpoTipo = 'html',
  status = 'enviado',
  mensagemErro = null,
} = {}) {
  const normalizedTabId = Number(tabId)
  const normalizedDestinatario = String(destinatarioEmail || '').trim()
  const normalizedAssunto = String(assunto || '').trim()
  const normalizedTabRef = String(tabRef || '').trim()

  if (!normalizedTabRef || !normalizedTabId || !normalizedDestinatario || !normalizedAssunto) {
    console.warn('registerEmailEnvio: campos obrigatórios ausentes', {
      tabRef: normalizedTabRef,
      tabId: normalizedTabId,
      destinatarioEmail: normalizedDestinatario,
      assunto: normalizedAssunto,
    })
    return null
  }

  const pfId = Number(store.getState()?.auth?.user?.pf_id) || null
  const payload = {
    emailEnvio_tabRef: normalizedTabRef,
    emailEnvio_tabId: normalizedTabId,
    emailEnvio_remetenteEmail: 'oikos@ecoss.is',
    emailEnvio_remetenteNome: 'Oikos',
    emailEnvio_destinatarioEmail: normalizedDestinatario,
    emailEnvio_assunto: normalizedAssunto.slice(0, 500),
    emailEnvio_corpoTipo: corpoTipo === 'texto' ? 'texto' : 'html',
    emailEnvio_status: status,
    emailEnvio_quantidadeTentativas: 1,
  }

  if (destinatarioNome != null && String(destinatarioNome).trim() !== '') {
    payload.emailEnvio_destinatarioNome = String(destinatarioNome).trim()
  }
  if (corpo != null) {
    payload.emailEnvio_corpo = corpo
  }
  if (pfId) {
    payload.pf_id = pfId
  }
  if (status === 'enviado') {
    payload.emailEnvio_enviadoEm = moment().format('YYYY-MM-DD HH:mm:ss')
  }
  if (mensagemErro) {
    payload.emailEnvio_mensagemErro = String(mensagemErro)
  }

  try {
    return await insert('emailEnvio', payload)
  } catch (error) {
    console.error('Falha ao registrar emailEnvio:', error)
    return null
  }
}

export async function sendFormEmail(data, assunto) {
  const intro = data.mensagemIntro ?? 'Por favor, preencha o formulário no link abaixo:';
  const corpoTitulo = data.corpoTitulo || 'Informações adicionais';
  const encerramento = data.mensagemEncerramento
    ?? 'Atenciosamente,<br/>Equipe Oikos';
  const htmlBody = printStandardEmail(
    `
      <span>Prezado(a)${data.nomeDest ? `, ${data.nomeDest}` : ''},</span><br/>
      <br/>
      <span>${intro}</span><br/>
      <br/>
      <a href="${data.formLink}" target="_blank">${data.formLinkLabel || data.formLink}</a><br/>
      ${data.corpo ? `
      <br/>
      <span>${corpoTitulo}:</span><br/>
      <span>${data.corpo}</span><br/>
      ` : ``}
      <br/>
      <span>${encerramento}</span>
    `
  );

  let success = false;
  let errorMessage = null;
  try {
    success = await sendEmailToNotify(data.emailDest, assunto, htmlBody, '');
    if (!success) {
      errorMessage = 'Falha ao enviar e-mail.';
    }
  } catch (error) {
    success = false;
    errorMessage = error?.message || 'Falha ao enviar e-mail.';
  }

  if (data.emailEnvioTabRef && data.emailEnvioTabId) {
    await registerEmailEnvio({
      tabRef: data.emailEnvioTabRef,
      tabId: data.emailEnvioTabId,
      destinatarioEmail: data.emailDest,
      destinatarioNome: data.nomeDest,
      assunto,
      corpo: htmlBody,
      corpoTipo: 'html',
      status: success ? 'enviado' : 'falha',
      mensagemErro: errorMessage,
    });
  }

  if (!success) {
    throw new Error(errorMessage || 'Falha ao enviar e-mail.');
  }

  return success;
}

// a função sendFormEmail deve receber um objeto (parâmetro data) que
// contenha o email do destinatário (nome da chave emailDest), nome do destinatário (nome da cheve nomeDest)
// e o link do formulário (nome da chave formLink).
// caso haja um corpo adicional para o email, adicionar na chave corpo no objeto data.
export async function sendFormNFEmail(data, assunto) {
  const htmlBody = printStandardEmail(
    `
      <span>Prezado(a), ${data.nomeDest}</span><br/>
      <br/>
      <span>Informamos que o seu contrato ${data.contrForn_desc}, de Objeto<br/>
      ${data.contrForn_obj}<br/>
      <br/>
      teve o evento ${data.contrFornEvento_desc} no valor de ${data.contrFornEvento_vlr}.<br/>
      Clique no link a seguir e faça a inserção da Nota Fiscal:
      </span><br/>
      <a href="${data.formLink}" target="_blank">${data.formLink}</a><br/>
      ${data.corpo ? `
      <span>Informações adicionais:</span><br/>
      <span>${data.corpo}</span><br/>
      <br/>
      ` : ``}
      <span>Obrigado!</span>
    `
  );

  let success = false;
  let errorMessage = null;
  try {
    success = await sendEmailToNotify(data.emailDest, assunto, htmlBody, '');
    if (!success) {
      errorMessage = 'Falha ao enviar e-mail.';
    }
  } catch (error) {
    success = false;
    errorMessage = error?.message || 'Falha ao enviar e-mail.';
  }

  if (data.emailEnvioTabRef && data.emailEnvioTabId) {
    await registerEmailEnvio({
      tabRef: data.emailEnvioTabRef,
      tabId: data.emailEnvioTabId,
      destinatarioEmail: data.emailDest,
      destinatarioNome: data.nomeDest,
      assunto,
      corpo: htmlBody,
      corpoTipo: 'html',
      status: success ? 'enviado' : 'falha',
      mensagemErro: errorMessage,
    });
  }

  return success;
}
